import React, { useState } from 'react';
import styled from 'styled-components';
import BaseButton from './BaseButton';

import { Colors } from '../../../../scss/common/style';

interface Props {
  size?: 'sm' | 'lg';
  onClick?: () => void;
  title?: string;
  isSubmitting?: boolean;
  active?: boolean;
  disabled?: boolean;
  type?: 'button' | 'reset' | 'submit';
  style?: any;
  width?: any;
}

export default function PrimaryAlternativeButton({
  onClick,
  title,
  isSubmitting = false,
  active = false,
  disabled = false,
  type,
  style,
  width,
}: Props): JSX.Element {
  return (
    <StyledButton width={width}>
      <BaseButton
        style={style}
        type={type}
        title={title}
        onClick={onClick}
        isSubmitting={isSubmitting}
        disabled={disabled}
        active={active}
      />
    </StyledButton>
  );
}

const StyledButton = styled.div`
  width: ${(props) => (props.width ? props.width : '')};
  button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${(props) => (props.width ? props.width : '')};
    text-align: center;
    background-color: ${Colors.darkBrown};
    color: #fff;
    border-radius: 200px;
    padding: 9px 37px;
    div {
      text-align: center;
    }
    &:hover {
      background: ${Colors.darkRed};
      border-color: ${Colors.darkRed};
      color: '#fff';
    }
    &:active {
      background: ${Colors.newOrage};
      border-color: ${Colors.newOrage};
    }
  }
`;
